import React, { forwardRef } from 'react'

import { Wrapper } from './Button.styles'

/**
 *
 */

const Button = forwardRef(
  // @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type '{ children... Remove this comment to see the full error message
  ({ type, variant, label, disabled, onClick }, ref) => (
    <Wrapper
      type={type}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      ref={ref}
    >
      {label}
    </Wrapper>
  ),
)

export default Button
